module.exports = __webpack_public_path__ + "static/poster.32ecd6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster.jpg
// module id = 1228
// module chunks = 35783957827783